export enum RevisionAssistantControlCode {
  noRuleComputed = 'no_rule_computed'
}
